const colors = {
  light: '#FFFFFF',
  dark: '#303030',
  darkest: '#232323',
  lime: '#48E73A',
}

export { colors }
